<template>
    <div class="eyTit">
        <h1 class="main">{{main}}</h1>
        <h6 class="sub">{{sub}}</h6>
    </div>
</template>

<script>
export default {
    props:['main','sub']
}
</script>

<style lang="scss" scoped>
.eyTit{
    h1,h6{
        margin: 0;
    }
    .main{
        font-size: vp(48);
        margin-bottom: vp(10);
        color: $yyBlue;
    }
    .sub{
        font-size: vp(18);
        margin-bottom: vp(30);
        font-weight: 400;
        color: rgba(51,51,51,.6);
    }
}

</style>